<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import AppBootSkeleton from '../../components/AppBootSkeleton.vue';
import { webAuth } from '../../auth/web-auth.js';

// `/auth/callback`: troca a sessão central por token e volta ao caminho interno seguro.
const route = useRoute();
const router = useRouter();
const failed = ref(false);

onMounted(async () => {
  try {
    await router.replace(await webAuth().completeCallback(route.query.returnTo));
  } catch {
    failed.value = true;
  }
});

function retry(): void {
  window.location.assign(webAuth().loginUrl(route.query.returnTo));
}
</script>

<template>
  <AppBootSkeleton v-if="!failed" />
  <main
    v-else
    class="auth-card"
  >
    <p role="alert">
      Não foi possível concluir o login.
    </p>
    <button
      type="button"
      @click="retry"
    >
      Tentar novamente
    </button>
  </main>
</template>

<style scoped>
.auth-card { max-width: 28rem; margin: 15vh auto; padding: 1.5rem; font-family: system-ui, sans-serif; text-align: center; }
button { margin-top: 1rem; padding: .5rem 1rem; font: inherit; cursor: pointer; }
</style>
